import routerOptions0 from "/home/runner/work/solo-brands-scaffolding/solo-brands-scaffolding/webapp/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}